import connector from "@/repository/connector";

export default {
  async list(params = {}) {
    return connector.requestWithFallback(
      () => connector.connector.get("campaigns/", { params }),
    );
  },
  async get(id) {
    return connector.requestWithFallback(
      () => connector.connector.get(`campaigns/${id}/`),
    );
  },
  async create(payload) {
    return connector.requestWithFallback(
      () => connector.connector.post("campaigns/", payload),
    );
  },
  async replace(id, payload) {
    return connector.requestWithFallback(
      () => connector.connector.put(`campaigns/${id}/`, payload),
    );
  },
  async update(id, payload) {
    return connector.requestWithFallback(
      () => connector.connector.patch(`campaigns/${id}/`, payload),
    );
  },
  async remove(id) {
    return connector.requestWithFallback(
      () => connector.connector.delete(`campaigns/${id}/`),
    );
  },
  async getGoalByUsername(username) {
    return connector.requestWithFallback(
      () => connector.connector.get(`campaigns/by_username/${username}/`),
    );
  },
  async stats(id) {
    return connector.requestWithFallback(
      () => connector.connector.get(`campaigns/${id}/stats/`),
    );
  },
  async exportCsv(payload) {
    return connector.requestWithFallback(
      () =>
        connector.connector.post(
          "campaigns/export_csv/",
          { start: payload.start, end: payload.end },
          { responseType: "blob" }
        ),
    );
  },
};
